import { Pipe, PipeTransform } from '@angular/core';
import { ClassicPreset } from 'rete';
import { Side } from 'rete-connection-plugin';
import { FlowNode, SocketData } from '../interfaces/flow-ui.interface';

@Pipe({
  name: 'socketData',
  standalone: true,
})
export class SocketDataPipe implements PipeTransform {
  public transform(
    { key, value }: { key: string; value: ClassicPreset.Output<any> | ClassicPreset.Input<any> },
    data: FlowNode,
    seed: number,
    side: Side,
  ): SocketData {
    return {
      type: 'socket',
      side,
      key,
      nodeId: data.id,
      payload: value?.socket,
      seed,
    };
  }
}
